import React from 'react'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import Amplify from 'aws-amplify'
import awsconfig from '../aws-exports'
import 'typeface-roboto'
import 'typeface-cormorant-garamond'
import CssBaseline from '@material-ui/core/CssBaseline'
import '../styles/index.scss'
import Header from '../components/Header'


Amplify.configure(awsconfig)
const stripePromise = loadStripe('pk_live_yjezmY1HoTsE3eHwJzDwS9IM')


const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#d2232a',
    }
  }
})


export default function PagesLayout({children}){
  return (
    <ThemeProvider theme={theme}>
      <Elements stripe={stripePromise}>
        <CssBaseline/>
        <Header/>
        <div className='wrapper'>
          {children}
        </div>
      </Elements>
    </ThemeProvider>
  )
}
